<section>
  <div class="col-12 my-4">
    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Task Guideline</button>
    </div>
</section>
<section *ngIf="user_role.roles ==='admin'" id="taskboard" class="app-taskboard">
  <div class="row">
    <div class="col-12">
      <div class="my-3">
        <button type="button" class="btn btn-primary mr-2" (click)="openModal(myModal)">
          <span class="d-flex align-items-center">
            <i class="ft-plus mr-1"></i>
            <span>Create</span>
          </span>
        </button>
      </div>
    </div>
  </div>
  <div class="row" >
    <div class="col-xl-3 col-sm-6 col-12">
      <h5 class="mt-2 mb-0">
        <span class="d-flex align-items-center">
          <i class="ft-cast mr-2"></i>
          <span>Normal</span>
        </span>
      </h5>
      <div class='dragdrop-container' [dragula]='"ITEMS"' [id]="normal_priority ">
        <div class="card mb-3" *ngFor="let item of taskData_normal; let normalIndex =index" [attr.task-index]="normalIndex" [attr.task-priority]="item.priority._id" [attr.task-priorityname]="item.priority.name">
          <div class="card-body">
            <div class="users-box d-flex justify-content-between mb-2">
              <span class="badge bg-light-primary mr-2" *ngFor="let item of item?.to">{{item?.name}}</span>
              <div class="edit-del-btn">
                <i class="ft-edit my-1 primary cursor-pointer" [routerLink]="['/task/edit',item._id]"></i>
                <i class="ft-trash-2 my-1  danger cursor-pointer" (click)="confirmDelete(item._id);"></i>
                <i class="ft-copy my-1 primary cursor-pointer" (click)="copyItem(item._id)"></i>

              </div>
            </div>
            <div>
              <span class="badge bg-light-info my-1 ">{{item?.title}} </span> <br>
              <span class="badge bg-light-primary my-1" placement="top" ngbTooltip="project">{{item?.type_projects[0]?.name}}</span><br>
              <span class="badge bg-light-primary my-1" placement="top" ngbTooltip="task stage">{{item?.stage?.displayname}}</span>
            </div>
            <p [innerHTML]="item.body"></p>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex font-small-2">
                <div class="mr-2" *ngIf="item.created_at!= ''"><i class="ft-clock mr-1"></i>{{item.created_at | date:'medium'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-sm-6 col-12">
      <h5 class="mt-2 mb-0">
        <span class="d-flex align-items-center">
          <i class="ft-cast mr-2"></i>
          <span>Medium</span>
        </span>
      </h5>
      <div class='dragdrop-container' [dragula]='"ITEMS"' [id]="medium_priority  ">
        <div class="card mb-3" *ngFor="let item of taskData_medium ; let mediumIndex=index" [attr.task-index]="mediumIndex" [attr.task-priority]="item.priority._id" [attr.task-priorityname]="item.priority.name">
          <div class="card-body">
            <div class="users-box d-flex justify-content-between mb-2">
              <span class="badge bg-light-success mr-2" *ngFor="let item of item?.to">{{item?.name}}</span>
              <div class="edit-del-btn">                
                <i class="ft-edit my-1 primary cursor-pointer" [routerLink]="['/task/edit',item._id]"></i>
                <i class="ft-trash-2 my-1 danger cursor-pointer" (click)="confirmDelete(item._id);"></i>
                <i class="ft-copy my-1 primary cursor-pointer" (click)="copyItem(item._id)"></i>

              </div>
            </div>
            <div>
              <span class="badge bg-light-info my-1">{{item?.title}} </span><br>
              <span class="badge bg-light-success my-1" placement="top" ngbTooltip="task stage">{{item?.stage?.displayname}}</span>
              
            </div>
            <p [innerHTML]="item.body"></p>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex font-small-2">
                <div class="mr-2" *ngIf="item.created_at!= ''"><i class="ft-clock mr-1"></i>{{item.created_at | date:'medium'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-sm-6 col-12">
      <h5 class="mt-2 mb-0">
        <span class="d-flex align-items-center">
          <i class="ft-cast mr-2"></i>
          <span>High</span>
        </span>
      </h5>
      <div class='dragdrop-container' [dragula]='"ITEMS"' [id]="high_priority   ">
        <div class="card mb-3" *ngFor="let item of taskData_high ; let highIndex =index" [attr.task-index]="highIndex" [attr.task-priority]="item.priority._id" [attr.task-priorityname]="item.priority.name">
          <div class="card-body">
            <div class="users-box d-flex justify-content-between mb-2">
              <span class="badge bg-light-warning mr-2" *ngFor="let item of item?.to">{{item?.name}}</span>
              <div class="edit-del-btn">
                <i class="ft-edit my-1 primary cursor-pointer" [routerLink]="['/task/edit',item._id]"></i>
                <i class="ft-trash-2 my-1 danger cursor-pointer" (click)="confirmDelete(item._id);"></i>
                <i class="ft-copy my-1 primary cursor-pointer" (click)="copyItem(item._id)"></i>

              </div>
            </div>
            <div>
              <span class="badge bg-light-info my-1">{{item?.title}} </span><br>
              <span class="badge bg-light-warning my-1" placement="top" ngbTooltip="task stage">{{item?.stage?.displayname}}</span>

            </div>
            <p [innerHTML]="item.body"></p>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex font-small-2">
                <div class="mr-2" *ngIf="item.created_at!= ''"><i class="ft-clock mr-1"></i>{{item.created_at | date:'medium'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-sm-6 col-12">
      <h5 class="mt-2 mb-0">
        <span class="d-flex align-items-center">
          <i class="ft-cast mr-2"></i>
          <span>Urgent</span>
        </span>
      </h5>
      <div class='dragdrop-container' [dragula]='"ITEMS"' [id]="urgent_priority    ">
        <div class="card mb-3" *ngFor="let item of taskData_urgent ; let urgentIndex=index" [attr.task-index]="urgentIndex" [attr.task-priority]="item.priority._id" [attr.task-priorityname]="item.priority.name">
          <div class="card-body">
            <div class="users-box d-flex justify-content-between mb-2">
              <span class="badge bg-light-danger mr-2" *ngFor="let item of item?.to">{{item?.name}}</span>
              <div class="edit-del-btn">
                <i class="ft-edit my-1 primary cursor-pointer" [routerLink]="['/task/edit',item._id]"></i>
                <i class="ft-trash-2 my-1 danger cursor-pointer" (click)="confirmDelete(item._id);"></i>
                <i class="ft-copy my-1 primary cursor-pointer" (click)="copyItem(item._id)"></i>

              </div>
            </div>
            <div>
              <span class="badge bg-light-info my-1">{{item?.title}}</span><br>
              <span class="badge bg-light-danger my-1" placement="top" ngbTooltip="task stage">{{item?.stage?.displayname}}</span>

            </div>
            <p [innerHTML]="item.body"></p>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex font-small-2">
                <div class="mr-2" *ngIf="item.created_at!= ''"><i class="ft-clock mr-1"></i>{{item.created_at | date:'medium'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>

<section *ngIf="user_role.roles ==='employee'" id="taskboard" class="app-taskboard">
  
  <div class="row">
    <div class="col-xl-6 col-sm-6 col-12">
      <h5 class="mt-2 mb-0">
        <span class="d-flex align-items-center">
          <i class="ft-cast mr-2"></i>
          <span>Current</span>
        </span>
      </h5>
      <div class='dragdrop-container' [dragula]='"ITEMS"' [id]="normal_priority ">
        <div class="card mb-3" *ngFor="let item of taskData_normal; let normalIndex =index" [attr.task-index]="normalIndex" [attr.task-priority]="item.priority._id" [attr.task-priorityname]="item.priority.name">
          <div class="card-body">
            <div class="d-flex justify-content-between mb-2">
              <span class="badge bg-light-primary mr-2" *ngFor="let item of item?.to">{{item?.name}}</span>
              <div class="edit-del-btn">
                <i class="ft-edit mr-1 primary cursor-pointer" [routerLink]="['/task/edit',item._id]"></i>
                <i class="ft-trash-2 danger cursor-pointer" (click)="confirmDelete(item._id);"></i>
              </div>
            </div>
            <div>
              <span class="badge bg-light-info my-2">{{item?.title}} </span>
            </div>
            <p [innerHTML]="item.body"></p>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex font-small-2">
                <div class="mr-2" *ngIf="item.created_at!= ''"><i class="ft-clock mr-1"></i>{{item.created_at | date:'medium'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-6 col-sm-6 col-12">
      <h5 class="mt-2 mb-0">
        <span class="d-flex align-items-center">
          <i class="ft-cast mr-2"></i>
          <span>Next</span>
        </span>
      </h5>
      <div class='dragdrop-container' [dragula]='"ITEMS"' [id]="medium_priority  ">
        <div class="card mb-3" *ngFor="let item of taskData_medium ; let mediumIndex=index" [attr.task-index]="mediumIndex" [attr.task-priority]="item.priority._id" [attr.task-priorityname]="item.priority.name">
          <div class="card-body">
            <div class="d-flex justify-content-between mb-2">
              <span class="badge bg-light-success mr-2" *ngFor="let item of item?.to">{{item?.name}}</span>
              <div class="edit-del-btn">
                <i class="ft-edit mr-1 primary cursor-pointer" [routerLink]="['/task/edit',item._id]"></i>
                <i class="ft-trash-2 danger cursor-pointer" (click)="confirmDelete(item._id);"></i>
              </div>
            </div>
            <div>
              <span class="badge bg-light-info mb-2">{{item?.title}}</span>

            </div>
            <p [innerHTML]="item.body"></p>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex font-small-2">
                <div class="mr-2" *ngIf="item.created_at!= ''"><i class="ft-clock mr-1"></i>{{item.created_at | date:'medium'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>

<!----- Add New Task Popup ----------->
<div>
	<ng-template #myModal let-modal>
		<div class="modal-header">
      <h3>Create Task</h3>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
      <div class="modal-body taskboard-modal">
        <form [formGroup]="myForm">
          <div class="container">
            <div class="d-flex icons-list">
              <div class="dropdown mr-2">
                <i class="fa-solid fa-user-tie fa-xl cursor-pointer" *ngIf="task_for_selected =='employee'"
                  placement="top"  [ngClass]="{'active-icon': task_for_selected =='employee' }" [ngbTooltip]="task_for_selected" id="dropdownMenuButton" data-toggle="dropdown"
                  (click)="isDropdownOpen = !isDropdownOpen"></i>
                <i class="fa-solid fa-user-graduate fa-xl cursor-pointer" *ngIf="task_for_selected =='student'"
                  placement="top" [ngClass]="{'active-icon': task_for_selected =='student' }" [ngbTooltip]="task_for_selected" id="dropdownMenuButton" data-toggle="dropdown"
                  (click)="isDropdownOpen = !isDropdownOpen"></i>
                  <div class="dropdown-menu" [class.show]="isDropdownOpen" aria-labelledby="dropdownMenuButton">
                    <span class="dropdown-item"  (click)="toggleActiveStudent('student'); isDropdownOpen = false">
                      <span class="active-tab cursor-pointer">Student</span>
                    </span>
                    <span class="dropdown-item" (click)="toggleActiveStudent('emp'); isDropdownOpen = false">
                      <span class="active-tab cursor-pointer">Employee</span>
                    </span>
                  </div>
              </div>
              <div class="dropdown mr-1">
                <i class="fa-solid fa-user fa-xl cursor-pointer" [ngClass]="{'active-icon': isStudentList}" placement="top" ngbTooltip="individual" id="dropdownMenuButton2" data-toggle="dropdown" *ngIf="isStudentList && !isBatchList && isStudent && !isEmployee"
                (click)="isDropdownOpen_student = !isDropdownOpen_student"></i>
                <i class="fas fa-users fa-xl cursor-pointer" [ngClass]="{'active-icon': isBatchList}" placement="top" ngbTooltip="batch" id="dropdownMenuButton2" data-toggle="dropdown" *ngIf="isBatchList && !isStudentList && isStudent && !isEmployee"
                (click)="isDropdownOpen_student = !isDropdownOpen_student"></i>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2" *ngIf="isStudent" [class.show]="isDropdownOpen_student">
                  <a class="dropdown-item" *ngIf="!isStudentList" (click)="toggleActive('student-ind'); isDropdownOpen_student = false">Individual</a>
                  <a class="dropdown-item" *ngIf="!isBatchList" (click)="toggleActive('student-batch') ; isDropdownOpen_student = false">Batch</a>
                </div>
              </div>
              <div class="dropdown mr-2">
                <i class="fa-solid fa-user fa-xl cursor-pointer" [ngClass]="{'active-icon': isEmpList}" placement="top" ngbTooltip="individual"  id="dropdownMenuButton3" data-toggle="dropdown" *ngIf="isEmpList && !isTeamList && !isStudentList && !isStudent && isEmployee"
                (click)="isDropdownOpen_employee = !isDropdownOpen_employee"></i>
                <i class="fa-solid fa-users fa-xl cursor-pointer" [ngClass]="{'active-icon': isTeamList}" placement="top" ngbTooltip="team"  id="dropdownMenuButton3" data-toggle="dropdown" *ngIf="isTeamList && !isEmpList && !isStudentList && !isStudent && isEmployee"
                (click)="isDropdownOpen_employee = !isDropdownOpen_employee"></i>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton3" *ngIf="isEmployee" [class.show]="isDropdownOpen_employee">
                  <a class="dropdown-item" *ngIf="!isEmpList" (click)="toggleActive('emp-ind')">Individual</a>
                  <a class="dropdown-item" *ngIf="!isTeamList" (click)="toggleActive('emp-team')">Team</a>
                </div>
              </div>
              <div class="dropdown mr-2">
                <span class="icon mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isScheduleList || selectedSchedule}" (click)="isScheduleList = !isScheduleList" placement="top" ngbTooltip="schedule" id="scheduleList" data-toggle="dropdown" ><i class="fa-solid fa-calendar-days fa-xl"></i></span>
                <div class="dropdown-menu hide-scroll" aria-labelledby="scheduleList">
                  <a class="dropdown-item" *ngFor="let item of scheduleList" [class.active]="item.id === selectedSchedule">
                    <span (click)="getChangeScheduleId(item.id)">{{item.name}}</span>
                  </a>
                </div>
              </div>
              <div class="dropdown">
                <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isPriorityList || selected_task_priority}" (click)="isPriorityList = !isPriorityList" placement="top" ngbTooltip="priority" id="priorityList" data-toggle="dropdown"><i class="fa-solid fa-layer-group fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="priorityList">
                  <a class="dropdown-item" *ngFor="let item of task_priority_List" [class.active]="item._id === selected_task_priority">
                    <span (click)="getChangeTaskPriority(item._id)">{{item.displayname}}</span>
                  </a>
                </div>
              </div>
              <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': selectedType}" (click)="isType = !isType" placement="top" ngbTooltip="Type"><i class="ft-grid fa-xl"></i></span>
              <div class="dropdown">
                <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isTaskLabel || selectedTaskLabel}" (click)="isTaskLabel = !isTaskLabel" placement="top" ngbTooltip="task label" id="task_labelList" data-toggle="dropdown"><i class="ft-tag fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="task_labelList">
                  <a class="dropdown-item" *ngFor="let item of taskLabelList" [class.active]="item._id === selectedTaskLabel">
                    <span (click)="getChangeTaskLabelId(item._id)">{{item.displayname}}</span>
                  </a>
                </div>
              </div>
              <div class="dropdown">
              <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon-danger': isMandatory || selectedMandatory}" (click)="isMandatory = !isMandatory" placement="top" ngbTooltip="mandatory" id="mandatoryList" data-toggle="dropdown"><i class="ft-alert-circle fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="mandatoryList">
                  <a class="dropdown-item" *ngFor="let item of mandatoryList" [class.active]="item.id === selectedMandatory">
                    <span (click)="getChangeMandatoryId(item.id)">{{item.name}}</span>
                  </a>
                </div>
              </div>
            
            </div>
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isEmpList || isTeamList ">
                <ng-select *ngIf="!isTeam_selected_list"
                      [items]="empList"
                      bindLabel="name"
                      bindValue="_id"
                      placeholder="Select Employee"
                      [(ngModel)]="selectedEmp"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      [ngModelOptions]="{ standalone: true }"
                      (open)="onDropdownOpenEmp($event)"
                      (close)="onDropdownCloseEmp($event)"
                    >
                    <ng-template ng-header-tmp>
                      <div class="checkbox-container">
                        <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionEmp()">
                        <span>Select All</span>
                      </div>
                    </ng-template>
                  
                    <ng-template ng-option-tmp let-item="item">
                      <div class="checkbox-container">
                        <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"  (change)="toggleSelectionEmp(item)">
                        <span>{{ item.name }}</span>
                      </div>
                    </ng-template>
                </ng-select>
                <ng-select *ngIf="isTeam_selected_list"
                [items]="team_selected_list"
                bindLabel="name"
                bindValue="_id"
                [multiple]="true"
                [closeOnSelect]="false"
                [(ngModel)]="team_selected_list_data"
                [ngModelOptions]="{ standalone: true }"
              >
            </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isTeamList ">
              <ng-select
                      [items]="teamList"
                      bindLabel="displayname"
                      bindValue="_id"
                      placeholder="Select Team"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      [(ngModel)]="selectTeam"
                      [ngModelOptions]="{ standalone: true }"
                      (open)="onDropdownOpenTeam($event)"
                      (close)="onDropdownCloseTeam($event)"  
                    >
                    <ng-template ng-header-tmp>
                      <div class="checkbox-container">
                        <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionTeam()">
                        <span>Select All</span>
                      </div>
                    </ng-template>
                  
                    <ng-template ng-option-tmp let-item="item">
                      <div class="checkbox-container">
                        <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"  (change)="toggleSelectionTeam(item)">
                        <span>{{ item.name }}</span>
                      </div>
                    </ng-template>
                </ng-select>
          </fieldset>
          <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isTeam_selected_list">
            <ng-select *ngIf="isTeam_selected_list"
              [items]="team_selected_list"
              bindLabel="name"
              bindValue="_id"
              [multiple]="true"
              [closeOnSelect]="false"
              [(ngModel)]="team_selected_list_data"
              [ngModelOptions]="{ standalone: true }"
            >
          </ng-select>
          </fieldset> -->
          <fieldset class="form-group position-relative has-icon-left" *ngIf="isStudentList || isBatchList && !isEmployee">
            <ng-select *ngIf="!isBatch_selected_list"
                  [items]="studentList"
                  bindLabel="name"
                  bindValue="id"
                  placeholder="Select Student"
                  [(ngModel)]="selectedStudent"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  [ngModelOptions]="{ standalone: true }"
                  (open)="onDropdownOpenStudent($event)"
                  (close)="onDropdownCloseStudent($event)"
                >
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionStudent()">
                    <span>Select All</span>
                  </div>
                </ng-template>
              
                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"  (change)="toggleSelectionStudent(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
                 <ng-template ng-multi-label-tmp let-items="items">
                  <div class="selected-items">
                    <ng-container *ngFor="let item of items; let i = index">
                      <div *ngIf="i < 5" class="chip">{{ item.name }}</div>
                    </ng-container>
                    <div *ngIf="items.length > 5" class="chip">+{{ items.length - 5 }} more</div>
                  </div>
                </ng-template>
            </ng-select>
            <ng-select *ngIf="isBatch_selected_list"
            [items]="batch_selected_list"
            bindLabel="name"
            bindValue="_id"
            [multiple]="true"
            [closeOnSelect]="false"
            [(ngModel)]="batch_selected_list_data"
            [ngModelOptions]="{ standalone: true }"
          >
        </ng-select>
            
        </fieldset>
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isBatchList && !isEmployee">
          <ng-select
                [items]="batchList"
                bindLabel="name"
                bindValue="_id"
                placeholder="Select Batch"
                [(ngModel)]="selectedBatch"
                [multiple]="true"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (open)="onDropdownOpenBatch($event)"
                (close)="onDropdownCloseBatch($event)"
              >
              <ng-template ng-header-tmp>
                <div class="checkbox-container">
                  <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionBatch()">
                  <span>Select All</span>
                </div>
              </ng-template>
            
              <ng-template ng-option-tmp let-item="item">
                <div class="checkbox-container">
                  <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"  (change)="toggleSelectionBatch(item)">
                  <span>{{ item.name }}</span>
                </div>
              </ng-template>
          </ng-select>
          
        </fieldset>
        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isBatch_selected_list">
          <ng-select
            [items]="batch_selected_list"
            bindLabel="name"
            bindValue="_id"
            [multiple]="true"
            [closeOnSelect]="false"
            [(ngModel)]="batch_selected_list_data"
            [ngModelOptions]="{ standalone: true }"
          >
        </ng-select>
        </fieldset> -->
        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isScheduleList">
          <ng-select
                [items]="scheduleList"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Schedule"
                [(ngModel)]="selectedSchedule"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeScheduleId($event)"
              >
          </ng-select>
          
        </fieldset> -->
        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isPriorityList">
          <ng-select
            [items]="task_priority_List"
            bindLabel="displayname"
            bindValue="_id"
            placeholder="Select Priority"
            [(ngModel)]="selected_task_priority"
            [ngModelOptions]="{ standalone: true }"
            (change)="getChangeTaskPriority($event)"
          >
          </ng-select>
          
        </fieldset> -->
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isType">
          <ng-select
                [items]="typeList"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Type"
                [(ngModel)]="selectedType"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeTypeId($event)"
              >
          </ng-select>
        </fieldset>
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isProjectList && !isCheckList && !isLeadType">
          <ng-select
                [items]="project_list"
                bindLabel="name"
                bindValue="_id"
                placeholder="Select Project"
                [multiple]="true"
                [closeOnSelect]="false"
                [(ngModel)]="select_project"
                [ngModelOptions]="{ standalone: true }"
                (change)="getProjectId($event)"
              >
          </ng-select>
        </fieldset>
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isCheckList && !isProjectList && !isLeadType">
          <ng-select
                [items]="check_list"
                bindLabel="name"
                bindValue="_id"
                placeholder="Select check"
                [multiple]="true"
                [closeOnSelect]="false"
                [(ngModel)]="select_checklist"
                [ngModelOptions]="{ standalone: true }"
                (change)="getCheckListId($event)"
              >
          </ng-select>
        </fieldset>
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isLeadType && !isCheckList && !isProjectList">
          <ng-select
                [items]="leads_type"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Lead"
                [(ngModel)]="select_leadType"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getLeadTypeId($event)"
              >
          </ng-select>
        </fieldset>
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isTrainingLead && !isOutsourceLead && !isCheckList && !isProjectList">
          <ng-select
                [items]="training_list"
                bindLabel="title"
                bindValue="_id"
                placeholder="Select Training"
                [(ngModel)]="select_training_lead"
                [closeOnSelect]="false"
                [multiple]="true"
                [ngModelOptions]="{ standalone: true }"
                (change)="getTrainingLeadId($event)"
              >
          </ng-select>
        </fieldset>
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isOutsourceLead && !isTrainingLead && !isCheckList && !isProjectList">
          <ng-select
                [items]="outsource_list"
                bindLabel="leads.title"
                bindValue="_id"
                placeholder="Select Outsource"
                [(ngModel)]="select_outsource_lead"
                [multiple]="true"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getOutsourceLeadId($event)"
              >
          </ng-select>
        </fieldset>
        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isTaskLabel">
          <ng-select
                [items]="taskLabelList"
                bindLabel="displayname"
                bindValue="_id"
                placeholder="Select TaskLabel"
                [(ngModel)]="selectedTaskLabel"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeTaskLabelId($event)"
              >
          </ng-select>
          
        </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left">
              <div class="form-control-position">
                <i class="ft-edit-2"></i> 
              </div>
              <input type="text" formControlName="title" class="form-control"
                id="todoTitle" placeholder="Title" (keydown.enter)="$event.preventDefault()" required #todoTitle>
              <div class="form-control-position control-position-right">
                <i class="ft-edit-2"></i>
              </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left">
              <div class="form-control-position">
                <i class="ft-message-square"></i>
              </div>
              <textarea  formControlName="body" class="form-control" placeholder="body">
              <div class="form-control-position control-position-right">
                <i class="ft-message-square"></i>
              </div>
            </textarea>
            </fieldset>
            <!-- <fieldset *ngIf="isMandatory">
              <ng-select
              [items]="mandatoryList"
              bindLabel="name"
              bindValue="id"
              placeholder="Select Mandatory"
              [(ngModel)]="selectedMandatory"
              [closeOnSelect]="false"
              [ngModelOptions]="{ standalone: true }"
              >
              </ng-select>
            </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left mt-2">
              <div class="form-control-position">
                <i class="fa-regular fa-calendar-days"></i> 
              </div>
              <input type="date" formControlName="due_date" [(ngModel)]="current_date" class="form-control" >
              <div class="form-control-position control-position-right">
                <i class="fa-regular fa-calendar-days"></i>
              </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left mt-2">
              <div class="form-control-position">
                <i class="ft-clock"></i> 
              </div>
              <input type="text" formControlName="time" [(ngModel)]="time" class="form-control" >
              <div class="form-control-position control-position-right">
                <i class="ft-clock"></i>
              </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left mt-2">
              <div class="form-control-position">
                <i class="ft-dollar-sign"></i> 
              </div>
              <input type="text" formControlName="budget" [(ngModel)]="budget_val" class="form-control" placeholder="Enter budget" >
              <div class="form-control-position control-position-right">
                <i class="ft-dollar-sign"></i>
              </div>
            </fieldset>
          </div>
        </form>
        
      </div>
		</div>
		<div class="modal-footer">
			<!-- <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button> -->
			<button type="button" class="btn btn-primary" (click)="createTask(formRef)">Create</button>
		  </div>
	</ng-template>
</div>


<!----- Add Demo Task Popup ----------->
<div>
	<ng-template #demoTask_modal let-modal>
		<div class="modal-header">
      <h3>Create Demo</h3>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
      <div class="modal-body taskboard-modal">
        <form [formGroup]="myForm">
          <div class="container">
            <div class="d-flex icons-list">
              <div class="dropdown mr-2">
                <i class="fa-solid fa-user-tie fa-xl cursor-pointer"
                  placement="top"  [ngClass]="{'active-icon': isEmpList }" [ngbTooltip]="task_for_selected" id="dropdownMenuButton" data-toggle="dropdown"
                  (click)="isDropdownOpen = !isDropdownOpen; isEmpList = !isEmpList"></i>
                
                  <!-- <div class="dropdown-menu" [class.show]="isDropdownOpen" aria-labelledby="dropdownMenuButton">
                    <span class="dropdown-item"  (click)="toggleActiveStudent('student'); isDropdownOpen = false">
                      <span class="active-tab cursor-pointer">Student</span>
                    </span>
                    <span class="dropdown-item" (click)="toggleActiveStudent('emp'); isDropdownOpen = false">
                      <span class="active-tab cursor-pointer">Employee</span>
                    </span>
                  </div> -->
              </div>
              <div class="dropdown mr-1">
                <i class="fa-solid fa-user-graduate fa-xl cursor-pointer"
                  placement="top" [ngClass]="{'active-icon': isStudentList }" id="dropdownMenuButton-demo" data-toggle="dropdown"
                  (click)="isDropdownOpen = !isDropdownOpen ; isStudentList = !isStudentList"></i>
                <!-- <i class="fa-solid fa-user fa-xl cursor-pointer" [ngClass]="{'active-icon': isStudentList}" placement="top" ngbTooltip="individual" id="dropdownMenuButton2" data-toggle="dropdown" *ngIf="isStudentList && !isBatchList && isStudent && !isEmployee"
                (click)="isDropdownOpen_student = !isDropdownOpen_student"></i>
                <i class="fas fa-users fa-xl cursor-pointer" [ngClass]="{'active-icon': isBatchList}" placement="top" ngbTooltip="batch" id="dropdownMenuButton2" data-toggle="dropdown" *ngIf="isBatchList && !isStudentList && isStudent && !isEmployee"
                (click)="isDropdownOpen_student = !isDropdownOpen_student"></i>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2" *ngIf="isStudent" [class.show]="isDropdownOpen_student">
                  <a class="dropdown-item" *ngIf="!isStudentList" (click)="toggleActive('student-ind'); isDropdownOpen_student = false">Individual</a>
                  <a class="dropdown-item" *ngIf="!isBatchList" (click)="toggleActive('student-batch') ; isDropdownOpen_student = false">Batch</a>
                </div> -->
              </div>
              <!-- <div class="dropdown mr-2">
                <i class="fa-solid fa-user fa-xl cursor-pointer" [ngClass]="{'active-icon': isEmpList}" placement="top" ngbTooltip="individual"  id="dropdownMenuButton3" data-toggle="dropdown" *ngIf="isEmpList && !isTeamList && !isStudentList && !isStudent && isEmployee"
                (click)="isDropdownOpen_employee = !isDropdownOpen_employee"></i>
                <i class="fa-solid fa-users fa-xl cursor-pointer" [ngClass]="{'active-icon': isTeamList}" placement="top" ngbTooltip="team"  id="dropdownMenuButton3" data-toggle="dropdown" *ngIf="isTeamList && !isEmpList && !isStudentList && !isStudent && isEmployee"
                (click)="isDropdownOpen_employee = !isDropdownOpen_employee"></i>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton3" *ngIf="isEmployee" [class.show]="isDropdownOpen_employee">
                  <a class="dropdown-item" *ngIf="!isEmpList" (click)="toggleActive('emp-ind')">Individual</a>
                  <a class="dropdown-item" *ngIf="!isTeamList" (click)="toggleActive('emp-team')">Team</a>
                </div>
              </div> -->
              <!-- <div class="dropdown mr-2" >
                <span class="icon mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isScheduleList || selectedSchedule}" (click)="isScheduleList = !isScheduleList" placement="top" ngbTooltip="schedule" id="scheduleList" data-toggle="dropdown" ><i class="fa-solid fa-calendar-days fa-xl"></i></span>
                <div class="dropdown-menu hide-scroll" aria-labelledby="scheduleList">
                  <a class="dropdown-item" *ngFor="let item of scheduleList" [class.active]="item.id === selectedSchedule">
                    <span (click)="getChangeScheduleId(item.id)">{{item.name}}</span>
                  </a>
                </div>
              </div>
              <div class="dropdown">
                <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isPriorityList || selected_task_priority}" (click)="isPriorityList = !isPriorityList" placement="top" ngbTooltip="priority" id="priorityList" data-toggle="dropdown"><i class="fa-solid fa-layer-group fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="priorityList">
                  <a class="dropdown-item" *ngFor="let item of task_priority_List" [class.active]="item._id === selected_task_priority">
                    <span (click)="getChangeTaskPriority(item._id)">{{item.displayname}}</span>
                  </a>
                </div>
              </div>
              <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': selectedType}" (click)="isType = !isType" placement="top" ngbTooltip="Type"><i class="ft-grid fa-xl"></i></span>
              <div class="dropdown">
                <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isTaskLabel || selectedTaskLabel}" (click)="isTaskLabel = !isTaskLabel" placement="top" ngbTooltip="task label" id="task_labelList" data-toggle="dropdown"><i class="ft-tag fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="task_labelList">
                  <a class="dropdown-item" *ngFor="let item of taskLabelList" [class.active]="item._id === selectedTaskLabel">
                    <span (click)="getChangeTaskLabelId(item._id)">{{item.displayname}}</span>
                  </a>
                </div>
              </div> -->
              <div class="dropdown">
              <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon-danger': isMandatory || selectedMandatory}" (click)="isMandatory = !isMandatory" placement="top" ngbTooltip="mandatory" id="mandatoryList" data-toggle="dropdown"><i class="ft-alert-circle fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="mandatoryList">
                  <a class="dropdown-item" *ngFor="let item of mandatoryList" [class.active]="item.id === selectedMandatory">
                    <span (click)="getChangeMandatoryId(item.id)">{{item.name}}</span>
                  </a>
                </div>
              </div>
            
            </div>
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isEmpList || isTeamList ">
                <ng-select *ngIf="!isTeam_selected_list"
                      [items]="empList"
                      bindLabel="name"
                      bindValue="_id"
                      placeholder="Select Employee"
                      [(ngModel)]="selectedEmp"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      [ngModelOptions]="{ standalone: true }"
                      (open)="onDropdownOpenEmp($event)"
                      (close)="onDropdownCloseEmp($event)"
                    >
                    <ng-template ng-header-tmp>
                      <div class="checkbox-container">
                        <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionEmp()">
                        <span>Select All</span>
                      </div>
                    </ng-template>
                  
                    <ng-template ng-option-tmp let-item="item">
                      <div class="checkbox-container">
                        <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"  (change)="toggleSelectionEmp(item)">
                        <span>{{ item.name }}</span>
                      </div>
                    </ng-template>
                </ng-select>
                <ng-select *ngIf="isTeam_selected_list"
                [items]="team_selected_list"
                bindLabel="name"
                bindValue="_id"
                [multiple]="true"
                [closeOnSelect]="false"
                [(ngModel)]="team_selected_list_data"
                [ngModelOptions]="{ standalone: true }"
              >
            </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isTeamList ">
              <ng-select
                      [items]="teamList"
                      bindLabel="displayname"
                      bindValue="_id"
                      placeholder="Select Team"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      [(ngModel)]="selectTeam"
                      [ngModelOptions]="{ standalone: true }"
                      (open)="onDropdownOpenTeam($event)"
                      (close)="onDropdownCloseTeam($event)"  
                    >
                    <ng-template ng-header-tmp>
                      <div class="checkbox-container">
                        <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionTeam()">
                        <span>Select All</span>
                      </div>
                    </ng-template>
                  
                    <ng-template ng-option-tmp let-item="item">
                      <div class="checkbox-container">
                        <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"  (change)="toggleSelectionTeam(item)">
                        <span>{{ item.name }}</span>
                      </div>
                    </ng-template>
                </ng-select>
          </fieldset>
          <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isTeam_selected_list">
            <ng-select *ngIf="isTeam_selected_list"
              [items]="team_selected_list"
              bindLabel="name"
              bindValue="_id"
              [multiple]="true"
              [closeOnSelect]="false"
              [(ngModel)]="team_selected_list_data"
              [ngModelOptions]="{ standalone: true }"
            >
          </ng-select>
          </fieldset> -->
          <fieldset class="form-group position-relative has-icon-left" *ngIf="isStudentList || isBatchList && !isEmployee">
            <ng-select *ngIf="!isBatch_selected_list"
                  [items]="studentList"
                  bindLabel="name"
                  bindValue="id"
                  placeholder="Select Student"
                  [(ngModel)]="selectedStudent"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  [ngModelOptions]="{ standalone: true }"
                  (open)="onDropdownOpenStudent($event)"
                  (close)="onDropdownCloseStudent($event)"
                >
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionStudent()">
                    <span>Select All</span>
                  </div>
                </ng-template>
              
                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"  (change)="toggleSelectionStudent(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
                 <ng-template ng-multi-label-tmp let-items="items">
                  <div class="selected-items">
                    <ng-container *ngFor="let item of items; let i = index">
                      <div *ngIf="i < 5" class="chip">{{ item.name }}</div>
                    </ng-container>
                    <div *ngIf="items.length > 5" class="chip">+{{ items.length - 5 }} more</div>
                  </div>
                </ng-template>
            </ng-select>
            <ng-select *ngIf="isBatch_selected_list"
            [items]="batch_selected_list"
            bindLabel="name"
            bindValue="_id"
            [multiple]="true"
            [closeOnSelect]="false"
            [(ngModel)]="batch_selected_list_data"
            [ngModelOptions]="{ standalone: true }"
          >
        </ng-select>
            
        </fieldset>
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isBatchList && !isEmployee">
          <ng-select
                [items]="batchList"
                bindLabel="name"
                bindValue="_id"
                placeholder="Select Batch"
                [(ngModel)]="selectedBatch"
                [multiple]="true"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (open)="onDropdownOpenBatch($event)"
                (close)="onDropdownCloseBatch($event)"
              >
              <ng-template ng-header-tmp>
                <div class="checkbox-container">
                  <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionBatch()">
                  <span>Select All</span>
                </div>
              </ng-template>
            
              <ng-template ng-option-tmp let-item="item">
                <div class="checkbox-container">
                  <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"  (change)="toggleSelectionBatch(item)">
                  <span>{{ item.name }}</span>
                </div>
              </ng-template>
          </ng-select>
          
        </fieldset>
        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isBatch_selected_list">
          <ng-select
            [items]="batch_selected_list"
            bindLabel="name"
            bindValue="_id"
            [multiple]="true"
            [closeOnSelect]="false"
            [(ngModel)]="batch_selected_list_data"
            [ngModelOptions]="{ standalone: true }"
          >
        </ng-select>
        </fieldset> -->
        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isScheduleList">
          <ng-select
                [items]="scheduleList"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Schedule"
                [(ngModel)]="selectedSchedule"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeScheduleId($event)"
              >
          </ng-select>
          
        </fieldset> -->
        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isPriorityList">
          <ng-select
            [items]="task_priority_List"
            bindLabel="displayname"
            bindValue="_id"
            placeholder="Select Priority"
            [(ngModel)]="selected_task_priority"
            [ngModelOptions]="{ standalone: true }"
            (change)="getChangeTaskPriority($event)"
          >
          </ng-select>
          
        </fieldset> -->
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isType">
          <ng-select
                [items]="typeList"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Type"
                [(ngModel)]="selectedType"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeTypeId($event)"
              >
          </ng-select>
        </fieldset>
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isProjectList && !isCheckList && !isLeadType">
          <ng-select
                [items]="project_list"
                bindLabel="name"
                bindValue="_id"
                placeholder="Select Project"
                [multiple]="true"
                [closeOnSelect]="false"
                [(ngModel)]="select_project"
                [ngModelOptions]="{ standalone: true }"
                (change)="getProjectId($event)"
              >
          </ng-select>
        </fieldset>
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isCheckList && !isProjectList && !isLeadType">
          <ng-select
                [items]="check_list"
                bindLabel="name"
                bindValue="_id"
                placeholder="Select check"
                [multiple]="true"
                [closeOnSelect]="false"
                [(ngModel)]="select_checklist"
                [ngModelOptions]="{ standalone: true }"
                (change)="getCheckListId($event)"
              >
          </ng-select>
        </fieldset>
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isLeadType && !isCheckList && !isProjectList">
          <ng-select
                [items]="leads_type"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Lead"
                [(ngModel)]="select_leadType"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getLeadTypeId($event)"
              >
          </ng-select>
        </fieldset>
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isTrainingLead && !isOutsourceLead && !isCheckList && !isProjectList">
          <ng-select
                [items]="training_list"
                bindLabel="title"
                bindValue="_id"
                placeholder="Select Training"
                [(ngModel)]="select_training_lead"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getTrainingLeadId($event)"
              >
          </ng-select>
        </fieldset>
        <fieldset class="form-group position-relative has-icon-left" *ngIf="isOutsourceLead && !isTrainingLead && !isCheckList && !isProjectList">
          <ng-select
                [items]="outsource_list"
                bindLabel="leads.title"
                bindValue="_id"
                placeholder="Select Outsource"
                [(ngModel)]="select_outsource_lead"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getOutsourceLeadId($event)"
              >
          </ng-select>
        </fieldset>
        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isTaskLabel">
          <ng-select
                [items]="taskLabelList"
                bindLabel="displayname"
                bindValue="_id"
                placeholder="Select TaskLabel"
                [(ngModel)]="selectedTaskLabel"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeTaskLabelId($event)"
              >
          </ng-select>
          
        </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left">
              <div class="form-control-position">
                <i class="ft-edit-2"></i> 
              </div>
              <input type="text" formControlName="title" class="form-control"
                id="todoTitle" placeholder="Title" (keydown.enter)="$event.preventDefault()" required #todoTitle>
              <div class="form-control-position control-position-right">
                <i class="ft-edit-2"></i>
              </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left">
              <div class="form-control-position">
                <i class="ft-message-square"></i>
              </div>
              <textarea  formControlName="body" class="form-control" placeholder="body">
              <div class="form-control-position control-position-right">
                <i class="ft-message-square"></i>
              </div>
            </textarea>
            </fieldset>
            <!-- <fieldset *ngIf="isMandatory">
              <ng-select
              [items]="mandatoryList"
              bindLabel="name"
              bindValue="id"
              placeholder="Select Mandatory"
              [(ngModel)]="selectedMandatory"
              [closeOnSelect]="false"
              [ngModelOptions]="{ standalone: true }"
              >
              </ng-select>
            </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left mt-2">
              <div class="form-control-position">
                <i class="fa-regular fa-calendar-days"></i> 
              </div>
              <input type="date" formControlName="due_date" [(ngModel)]="current_date" class="form-control" >
              <div class="form-control-position control-position-right">
                <i class="fa-regular fa-calendar-days"></i>
              </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left mt-2">
              <div class="form-control-position">
                <i class="ft-clock"></i> 
              </div>
              <input type="text" formControlName="time" [(ngModel)]="time" class="form-control" >
              <div class="form-control-position control-position-right">
                <i class="ft-clock"></i>
              </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left mt-2">
              <div class="form-control-position">
                <i class="ft-dollar-sign"></i> 
              </div>
              <input type="text" formControlName="budget" [(ngModel)]="budget_val" class="form-control" placeholder="Enter budget" >
              <div class="form-control-position control-position-right">
                <i class="ft-dollar-sign"></i>
              </div>
            </fieldset>
          </div>
        </form>
        
      </div>
		</div>
		<div class="modal-footer">
			<!-- <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button> -->
			<button type="button" class="btn btn-primary" (click)="createTask(formRef)">Create</button>
		  </div>
	</ng-template>
</div>

<div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>